import { render, staticRenderFns } from "./SubTypeTab.vue?vue&type=template&id=38021846"
import script from "./SubTypeTab.js?vue&type=script&lang=js&external"
export * from "./SubTypeTab.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports